import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_API = Symbol('affiliate.api');
export const AFFILIATE_API_ROUTE_NAME = Symbol('affiliate.api');

export const AFFILIATE_API_QUERY_KEY = 'affiliate-api';
export const AFFILIATE_API_API_URL = 'affiliate/settings/api_token';

export const AFFILIATE_API_MUTATION_KEY = 'affiliate-api-reset-token';
export const AFFILIATE_API_MUTATION_API_URL = 'affiliate/api_tokens_refresh';

export const AFFILIATE_API_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.SETTINGS_API_STATS),
};
